import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider';

import { authConfig } from './config';

/**
 * Singleton Cognito client.
 *
 * Cognito's unauthenticated commands (`InitiateAuth`, `SignUp`,
 * `ForgotPassword`, `ConfirmForgotPassword`, ...) don't require AWS SigV4
 * signing — they're public endpoints scoped by ClientId. We pass empty
 * credentials so the SDK doesn't go hunting for an IAM identity in the
 * browser (which doesn't have one) and emit warnings.
 */
export const cognitoClient = new CognitoIdentityProviderClient({
  region: authConfig.region,
  credentials: { accessKeyId: '', secretAccessKey: '' },
});
